<template>
  <p class="text-text-error heading-xxs">
    <slot />
  </p>
</template>

<script lang="ts" setup></script>
